exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--2b37lJLc2jKADvxata1eq5 {\n  background: none;\n  font-size: 10px;\n  font-weight: 400;\n  padding: 6px 20px;\n  color: #00498a;\n  border: 1px solid #00498a;\n  border-radius: 4px;\n}\n\n.waiting-room-sidebar--2b37lJLc2jKADvxata1eq5:disabled {\n  color: #696b6b;\n  border: 1px solid #696b6b;\n}\n", ""]);

// exports
exports.locals = {
	"sidebarButton": "waiting-room-sidebar--2b37lJLc2jKADvxata1eq5",
	"sidebarButton": "waiting-room-sidebar--2b37lJLc2jKADvxata1eq5"
};